import {ModalHeader} from '@chakra-ui/react';
import {useSelector} from 'react-redux';

export default function ChakraModalHeader({children, ...props}) {
    const {darkMode} =useSelector((state) => state.settings);
    return <ModalHeader {...props} color={darkMode ? 'white': 'black'}>{children}</ModalHeader>;
}
